/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialExportTournament
 */
export interface FinancialExportTournament {
    /**
     * 
     * @type {string}
     * @memberof FinancialExportTournament
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialExportTournament
     */
    name?: string;
}

/**
 * Check if a given object implements the FinancialExportTournament interface.
 */
export function instanceOfFinancialExportTournament(value: object): value is FinancialExportTournament {
    return true;
}

export function FinancialExportTournamentFromJSON(json: any): FinancialExportTournament {
    return FinancialExportTournamentFromJSONTyped(json, false);
}

export function FinancialExportTournamentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialExportTournament {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function FinancialExportTournamentToJSON(json: any): FinancialExportTournament {
    return FinancialExportTournamentToJSONTyped(json, false);
}

export function FinancialExportTournamentToJSONTyped(value?: FinancialExportTournament | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

